import SelectMenu from "../../../controls/SelectMenu";

export default function FlowReportsFilters(props) {
  const { filters, setFilters, products } = props;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3">
      <SelectMenu
        title="Product"
        handleInputChange={(e) =>
          setFilters({ ...filters, product: e.target.value })
        }
        name="product"
        options={products}
        value={filters.product}
      />
    </div>
  );
}
